/** Leva ao fim a área que rola em volta de `el` (o primeiro ancestral com rolagem; senão, a janela). */
export function scrollToEnd(el: HTMLElement | null): void {
  for (let p = el?.parentElement; p; p = p.parentElement) {
    if (p.scrollHeight > p.clientHeight && /(auto|scroll)/.test(getComputedStyle(p).overflowY)) {
      p.scrollTop = p.scrollHeight;
      return;
    }
  }
  if (el) window.scrollTo(0, document.documentElement.scrollHeight);
}
